import { render, staticRenderFns } from "./ProfileMenuSelectionMobile.vue?vue&type=template&id=1f3e86d2&scoped=true"
import script from "./ProfileMenuSelectionMobile.vue?vue&type=script&lang=js"
export * from "./ProfileMenuSelectionMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f3e86d2",
  null
  
)

export default component.exports